import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import "../../styles/projectStyles/ProjectDescription.css";

const ProjectDescription = forwardRef(({ data, setData }, ref) => {
  const [formData, setFormData] = useState(() => {
    const savedData =
      JSON.parse(localStorage.getItem("projectDescription")) || {};
    return {
      address: data?.address || savedData.address || "",
      housecode: data?.housecode || savedData.housecode || "",
      phoneNumber: data?.phoneNumber || savedData.phoneNumber || "",
      email: data?.email || savedData.email || "",
      overview: data?.overview || savedData.overview || "",
      Status: data?.Status || savedData.Status || "Not Started",
    };
  });

  const [errors, setErrors] = useState({});
  const [isTouched, setIsTouched] = useState(false); // Track whether the form has been submitted
  useEffect(() => {
    localStorage.setItem("projectDescription", JSON.stringify(formData));
  }, [formData]);
  const validateField = (key, value) => {
    let error = "";

    switch (key) {
      case "address":
        error = value.trim() === "" ? "Address is required." : "";
        break;
      case "housecode":
        error = value.trim() === "" ? "House code is required." : "";
        break;
      case "phoneNumber":
        const sanitizedValue = value.replace(/\s+/g, ""); // Remove all spaces
        if (sanitizedValue.trim() === "") {
          error = "Phone number is required.";
        } else if (!/^\d+$/.test(sanitizedValue)) {
          error = "Phone number should contain only numbers.";
        }
        break;
      case "email":
        if (value.trim() === "") {
          error = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
          error = "Please enter a valid email address.";
        }
        break;
      case "overview":
        error = value.trim() === "" ? "Project overview is required." : "";
        break;
      default:
        break;
    }

    return error;
  };

  const validateForm = () => {
    const newErrors = {};
    let valid = true;

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) valid = false;
      newErrors[key] = error;
    });

    setErrors(newErrors);
    return valid; // Return overall validation status
  };

  useImperativeHandle(ref, () => ({
    validateForm: () => {
      setIsTouched(true); // Set touched when validation is triggered
      return validateForm();
    },
  }));

  const handleInputChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="project-description-container">
      <div className="projectscreen">
        <div className="projectdescription-header-container">
          <h3 className="form-title">Project Description</h3>
          <div className="description-form-container">
            <form>
              <h3 className="row-title">House Details</h3>
              <div className="row">
                <div className="input-group">
                  <label htmlFor="address">Address</label>
                  <input
                    type="text"
                    id="address"
                    placeholder="Enter Address"
                    value={formData.address}
                    onChange={(e) =>
                      handleInputChange("address", e.target.value)
                    }
                  />
                  {isTouched && errors.address && (
                    <span className="error-text">{errors.address}</span>
                  )}
                </div>
                <div className="input-group">
                  <label htmlFor="zipCode">Postal Code</label>
                  <input
                    type="text"
                    id="zipCode"
                    placeholder="Enter Zip Code"
                    value={formData.housecode}
                    onChange={(e) =>
                      handleInputChange("housecode", e.target.value)
                    }
                  />
                  {isTouched && errors.housecode && (
                    <span className="error-text">{errors.housecode}</span>
                  )}
                </div>
              </div>
              <hr />

              <h3 className="row-title">Contact Details</h3>
              <div className="row">
                <div className="input-group">
                  <label htmlFor="phoneNumber">Phone Number</label>
                  <input
                    type="tel"
                    id="phoneNumber"
                    placeholder="+1 224 457 5454"
                    value={formData.phoneNumber}
                    onChange={(e) =>
                      handleInputChange("phoneNumber", e.target.value)
                    }
                  />
                  {isTouched && errors.phoneNumber && (
                    <span className="error-text">{errors.phoneNumber}</span>
                  )}
                </div>
                <div className="input-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    placeholder="Enter valid email"
                  />
                  {isTouched && errors.email && (
                    <span className="error-text">{errors.email}</span>
                  )}
                </div>
              </div>
              <hr />

              <h3 className="row-title">Project Overview</h3>
              <div className="input-grp">
                <textarea
                  className="overviewproj"
                  id="overview"
                  placeholder="Enter project description"
                  value={formData.overview}
                  onChange={(e) =>
                    handleInputChange("overview", e.target.value)
                  }
                />
                {isTouched && errors.overview && (
                  <span className="error-text">{errors.overview}</span>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ProjectDescription;
